import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { CenterDto } from '@malirang/api-client';
import { CenterRoleStore } from 'apps/client/src/stores/center/role.store';

@Component({
  selector: 'app-center-role-badge',
  template: `
    @if (role(); as role) {
      <div class="text-gray-500 bg-gray-100 px-2 py-1 text-xs rounded-lg">
        {{ role.name }}
      </div>
    } @else {
      <div class=" px-2 py-1 text-xs rounded-lg bg-neutral-300 text-white ">
        미소속
      </div>
    }
  `,
  imports: [CommonModule],
})
export class CenterRoleBadgeComponent {
  center = input<CenterDto>();
  readonly centerRoleStore = inject(CenterRoleStore);
  myRole = this.centerRoleStore.myRole;

  /**
   * props로 받은 center가 있으면 center의 role을 반환
   * 없으면 store의 role을 반환
   */
  role = computed(() => {
    if (this.center()) {
      return this.center()?.myRole;
    }

    return this.myRole();
  });
}
